import './headline.css';

export function Headline(props) {
  return (
    <div className="headlineContainer">
      <h2 style={{ fontSize: `${props.size}px` }}>{props.title}</h2>
    </div>
  );
}
